import React from 'react';
import PropTypes from 'prop-types';
import {
  PRIMARY_BUTTON_VARIANTS,
  getPrimaryButtonConfig,
} from '../../util/address-validation/getAddressValidationDisplay';

/**
 * The form's primary button. It either submits the selected address or — when
 * there is nothing to submit — sends the user back to the edit form.
 *
 * getPrimaryButtonConfig owns the choice; this only renders it.
 */
export const AddressValidationPrimaryButton = ({
  addressValidationError,
  confirmedSuggestions,
  isLoading,
  onEditClick,
  overrideValidationKey,
  selectedAddressId,
}) => {
  const { variant, loading, text } = getPrimaryButtonConfig({
    addressValidationError,
    overrideValidationKey,
    confirmedSuggestions,
    selectedAddressId,
    isLoading,
  });

  if (variant === PRIMARY_BUTTON_VARIANTS.EDIT) {
    return (
      <va-button
        data-testid="edit-address-button"
        onClick={onEditClick}
        label="Edit address"
        text="Edit"
        class="vads-u-margin-top--1 vads-u-width--full mobile-lg:vads-u-width--auto"
      />
    );
  }

  return (
    <va-button
      data-testid="confirm-address-button"
      loading={loading}
      submit="prevent"
      text={text}
      class="vads-u-margin-top--1 vads-u-margin-bottom--1 vads-u-width--full mobile-lg:vads-u-width--auto"
    />
  );
};

AddressValidationPrimaryButton.propTypes = {
  addressValidationError: PropTypes.bool,
  confirmedSuggestions: PropTypes.array,
  isLoading: PropTypes.bool,
  overrideValidationKey: PropTypes.number,
  selectedAddressId: PropTypes.string,
  onEditClick: PropTypes.func,
};

export default AddressValidationPrimaryButton;
